import React, { memo } from "react";
//img
import previousBtn from "../../../assets/images/svg/leftarrow.svg";
import previousBtnFade from "../../../assets/images/svg/leftarrowfade.svg";
import nextBtn from "../../../assets/images/svg/rightarrow.svg";
import nextBtnFade from "../../../assets/images/svg/rightarrowfade.svg";
import Tooltip from '@mui/material/Tooltip';

//css
import classes from "./Pagination.module.css";

const PaginationComponent = ({
  currentPage,
  itemsPerPage,
  totalItems,
  disableNext,
  disablePrevious,
  previouPageClick,
  nextPageClick,
  pageNumber,
  setPageNumber,
  localStorageKey,
  rowsPerPage,
  rowsPerPageOptions = [],
  onRowsPerPageChange,
}) => {
  const normalizedItemCount = Number.isFinite(parseInt(itemsPerPage, 10))
    ? Math.max(parseInt(itemsPerPage, 10), 0)
    : 0;
  const parsedTotalPages = Number.isFinite(parseInt(totalItems, 10))
    ? Math.max(parseInt(totalItems, 10), 0)
    : 0;
  const totalPages = normalizedItemCount === 0 ? 0 : parsedTotalPages;
  const inputValue = totalPages === 0 ? "0" : pageNumber;

  const onPageChange = (e) => {
    const {
      target: { value },
    } = e;
    let numberRegex = /^\d+$/;
    if (totalPages === 0) return;
    if (
      (numberRegex.test(value) &&
        parseInt(value) >= 1 &&
        parseInt(value) <= totalPages) ||
      value === ""
    ) {
      if (value && localStorageKey) {
        localStorage[localStorageKey] = value;
      }
      setPageNumber(value);
    }
  };

  const showRowsPerPage =
    typeof rowsPerPage !== "undefined" &&
    Array.isArray(rowsPerPageOptions) &&
    rowsPerPageOptions.length > 0 &&
    typeof onRowsPerPageChange === "function";

  return (
    <div className={`${classes.pagination}`}>
      <span className={`${classes.pagination_text}`}>
        {`Total count`} <span>{normalizedItemCount}</span>
      </span>
      <span className={`${classes.pagination_text}`}>|</span>

      {/* {showRowsPerPage ? (
        <>
          <label className={`${classes.pagination_text} ${classes.pagination_select_wrap}`}>
            {`Rows per page`}
            <select
              value={rowsPerPage}
              onChange={onRowsPerPageChange}
              className={classes.pagination_select}
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </label>
          <span className={`${classes.pagination_text}`}>|</span>
        </>
      ) : null} */}

      <span className={`${classes.pagination_text}`}>
        {`Go to page`}{" "}
        <Tooltip title="Go to page">
          <input
            type="text"
            value={inputValue}
            onChange={onPageChange}
            disabled={totalPages === 0}
          />
        </Tooltip>{" "}
        of {totalPages}{" "}
      </span>

      <button
        className={`${classes.pagination_button}`}
        onClick={() => previouPageClick()}
        disabled={disablePrevious || totalPages === 0}
      >
        <img
          src={!disablePrevious && totalPages > 0 ? previousBtn : previousBtnFade}
          alt="Previous"
        />
      </button>

      <button
        className={`${classes.pagination_button}`}
        onClick={() => nextPageClick()}
        disabled={disableNext || totalPages === 0}
      >
        <img
          src={!disableNext && totalPages > 0 ? nextBtn : nextBtnFade}
          alt="Next"
        />
      </button>
    </div>
  );
};

export default memo(PaginationComponent);
